module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pembayaran'
      }
    }
  }, [_vm._v("List Pembayaran User")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Detail Pembayaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Detail Pembayaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.data.status === _vm.status.CONFIRMED) ? _c('div', {
    staticClass: "pull-right"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((this.statusAction), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.updatePembayaranStatus(key)
        }
      }
    }, [_vm._v(_vm._s(value))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Order ID : " + _vm._s(_vm.data.code))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                                " + _vm._s(message) + "\n                            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_name),
      expression: "data.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_email),
      expression: "data.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nomor Telepon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.phone_number),
      expression: "data.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "type", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Dari Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bank_name),
      expression: "data.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Ke Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payment_bank_name),
      expression: "data.payment_bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.payment_bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payment_bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tanggal Transfer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.transfer_datetime),
      expression: "data.transfer_datetime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.transfer_datetime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "transfer_datetime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    _vm.data.status !== _vm.status.CHECKOUT &&
    _vm.data.status !== _vm.status.EXPIRED
  ) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bukti Transfer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.receipt_img
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "status", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                            Action "), _c('span', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cca85ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/PembayaranDetail.vue
// module id = 1995
// module chunks = 1